import { getHashParams } from '../helpers/';

let access_token, expires_in, expires_at;

 const initialState = {
     accessToken: access_token,
     user: undefined,
     balances: {
         ltc: 0
     }
 }
 
 if (getHashParams().access_token) {
   console.log('[token manager] access_token in hash params');
   access_token = getHashParams().access_token;
   expires_in = getHashParams().expires_in;
   expires_at = new Date(Date.now() + (expires_in * 1000));
 
   localStorage.setItem('access_token', access_token);
   localStorage.setItem('expires_at', expires_at);
 } else if (localStorage.access_token) {
   console.log('[token manager] access_token in localStorage');
   expires_at = localStorage.expires_at;
   if (expires_at && new Date(expires_at) > new Date(Date.now() + (1000 * 60 * 60 * 24 * 7))) {
     access_token = localStorage.access_token;
   } else {
     localStorage.removeItem('expires_at');
     localStorage.removeItem('access_token');
   }
 } else {
   console.log('no access token');
 }
 

 function userUpdate(user){
   initialState.filter(user => user);
}

function logout() {
  initialState.filter(user => undefined);
  initialState.filter(accessToken => undefined);
}

export default function auth(state = initialState, action) {
    switch(action.type) {
       case 'USER_LOGIN':
         return [...state, {
           user: userUpdate
         }]
      case "USER_LOGOUT":
        return logout
      default:
         return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/auth.js